export const DESKTOP_BATCH = {
    initial: 25,
    subsequent: 15,
    initialMinimum: 15,
    initialShimmer: 10,
} as const;

/** Desktop AB variant: ML5+SL5+ML10+SL5 initial, then ML10+SL5 per loadNext. */
export const DESKTOP_VARIANT_BATCH = {
    initial: 15,
    subsequent: 10,
    initialMinimum: 15,
    initialShimmer: 10,
} as const;

export const MOBILE_BATCH = {
    initial: 20,
    subsequent: 6,
    initialMinimum: 6,
    initialShimmer: 4,
} as const;

export const DESKTOP_SENTINEL_ROOT_MARGIN = '0px 0px 1000px 0px';
export const MOBILE_SENTINEL_ROOT_MARGIN = '0px 0px 900px 0px';

/** Topsort ID pool size (not inflated count). */
export const PDP_INFINITE_SCROLL_SPONSORED_PAGE_SIZE = 110;
export const PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT = 10;
export const PDP_INFINITE_SCROLL_SL_INITIAL = 10;
/** Initial inflate: carousel 10 + first 2 grid SL rows. */
export const PDP_INFINITE_SCROLL_SL_INITIAL_INFLATE =
    PDP_INFINITE_SCROLL_CAROUSEL_SL_COUNT + PDP_INFINITE_SCROLL_SL_INITIAL;
export const PDP_INFINITE_SCROLL_SL_SUBSEQUENT = 5;

export const PDP_INFINITE_SCROLL_ITEMS_PER_ROW = 5;

/** 0-indexed row indices 1, 4, 7… (= display rows 2, 5, 8…) up to row 60. */
export const PDP_SPONSORED_ROW_INDICES: readonly number[] = Array.from(
    { length: 20 },
    (_, i) => 1 + i * 3
);
